module.exports = __webpack_public_path__ + "static/media/Right.9b6e72f9.svg";